import { render, staticRenderFns } from "./caseSign.vue?vue&type=template&id=4912fb2e&scoped=true"
import script from "./caseSign.vue?vue&type=script&lang=js"
export * from "./caseSign.vue?vue&type=script&lang=js"
import style0 from "./caseSign.vue?vue&type=style&index=0&id=4912fb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4912fb2e",
  null
  
)

export default component.exports